module.exports = __webpack_public_path__ + "static/media/external-link-alt.18b41ab2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/external-link-alt.svg
// module id = 303
// module chunks = 0